import { isSquadDynamicCell } from './squadFondsdatenDynamic';
import { SQUAD_DEFAULT_ISIN } from './templateConstants';

/**
 * One ISIN per SQUAD document: the "Fonds-ISIN" (`historyIsin`). NAV chart, SRRI, WKN and
 * every other dynamic value follow it. Two more places used to hold an ISIN of their own —
 * the Fondsdaten row and the rolling bars — and both drifted: SQUAD-TEST showed Green
 * Balance in the table and Value A in the bars. A clone of the master would have kept the
 * master's in both. They now mirror the fund ISIN on load, on edit and on save.
 */

const clean = (value: unknown) => String(value ?? '').trim().toUpperCase();

/**
 * Fund ISIN of a stored document (`additional_fields`). Documents without `historyIsin`
 * fall back to a typed Fondsdaten ISIN before the template default.
 */
export function squadFundIsinFromAdditional(additional: any): string {
  const fromHistory = clean(additional?.historyIsin);
  if (fromHistory) return fromHistory;
  const typed = additional?.fondsdaten?.isin;
  if (!isSquadDynamicCell(typed)) {
    const fromFondsdaten = clean(typed);
    if (fromFondsdaten) return fromFondsdaten;
  }
  return SQUAD_DEFAULT_ISIN;
}

/** Copy of the form data whose Fondsdaten row and rolling bars carry the fund ISIN. */
export function syncSquadFundIsin<T extends Record<string, any> | null | undefined>(data: T): T {
  if (!data) return data;
  const fundIsin = clean(data.historyIsin);
  if (!fundIsin) return data;
  const next: Record<string, any> = { ...data };
  if (data.fondsdaten && typeof data.fondsdaten === 'object') {
    next.fondsdaten = { ...data.fondsdaten, isin: fundIsin };
  }
  if (data.rollingPerformance && typeof data.rollingPerformance === 'object') {
    next.rollingPerformance = { ...data.rollingPerformance, isin: fundIsin };
  }
  return next as T;
}
